<template>
  <router-view />
</template>

<script setup>
import { provide } from 'vue'
import { useAdmin } from './composables/useAdmin'
import { useCustomer } from './composables/useCustomer'

const admin = useAdmin()
const customer = useCustomer()
provide('admin', admin)
provide('customer', customer)
</script>
